import React, { useState } from 'react';
import YouTubePlayer from './YouTubePlayer';

const VideoModal = ({ modalOpen, toggleModalStatus }) => {
  let [controls, setControls] = useState();

  let closeModal = () => {
    toggleModalStatus(false);
    controls.stopVideo();
  }

  let receiveControls = (controls) => {
    if (controls) {
      setControls(controls);
    }
  }

  return (
    <div id="video-modal" className="video-modal" style={modalOpen ? { visibility: "visible", opacity: 1 } : { visibility: "hidden", opacity: 0 }}>
      <div className="close-btn" onClick={() => closeModal()}><span><i className="fas fa-times"></i></span></div>
      <div className="video-modal-content">
        {
          modalOpen
            ?
            <YouTubePlayer controlsInModal={receiveControls} />
            :
            <div></div>
        }
      </div>
    </div>
  );
};

export default VideoModal;
